import React from "react";
import { Phone } from "lucide-react";

export default function CallButton() {
  return (
    <div className="call-btn">
      <a href="tel:+381600737363" aria-label="Pozovi Mihaila">
        <Phone size={18} strokeWidth={2.2} />
      </a>
    </div>
  );
}
